import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { CardDb } from '../redux/cardDbSlice';

const useAllCardDbsInBook = (bookId: string | null) : [string[], CardDb[]] => {
  const sheetTrees = useSelector((state: RootState) => state.sheetTreeDb).sheetTrees;
  const cards = useSelector((state: RootState) => state.cardDb).cards;
  const sheetTreeIds = Object.keys(sheetTrees).filter(id => sheetTrees[id].bookId === bookId);
  const sheetIds = sheetTreeIds.map(id => sheetTrees[id].sheetId);

  let ids: string[] = new Array(0);
  sheetIds.forEach(sheetId => {
    const cardIds = Object.keys(cards).filter(id => cards[id].sheetId === sheetId);
    cardIds.forEach(id => ids.push(id));
  })
  const values = ids.map(id => cards[id]);

  return [ids, values];
}

export default useAllCardDbsInBook;
